import {Injectable} from "@angular/core";
import {ApiProvider} from "../api/api";
import {SettingsProvider} from "../settings";

@Injectable()
export class ApiPromise {

    constructor(public api: ApiProvider,
                public set: SettingsProvider) {
    }

    obter(cacheName, apiUrl) {
        return new Promise((resolve, reject) => {
            this.set.loadCachedData(cacheName)
                .then((res: any) => {
                    if (!res) {
                        this.api.obter(apiUrl).then((data: any) => {
                            if(cacheName != 'nocache') {
                                this.set.saveCachedData(cacheName, data);
                            }
                            if (data != undefined) {
                                resolve(data)
                            }
                        }, (err: any) => {
                            if (err != undefined) {
                                    reject(err)
                            }
                        });
                    } else {
                        resolve(res);
                    }
                }, (err: any) => {
                    if (err != undefined) {
                            reject(err)
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/promises/api.promise.ts